import React, { useContext } from 'react';
import { ETables } from '../../types/enums/ETables';
import TableWithState from '../../components/TableWithState/TableWithState';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import { NSPromoCampaigns } from '../../types/interfaces/NSPromoCampaigns';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import { SessionContext } from '../../contexts/session/SessionContext';

const PromoCampaigns = () => {
  const cellStyleHandler = useCellStatusStyleHandler();
  const { permissions } = useContext(SessionContext);

  const dataFormatter = (dataTable: NSPromoCampaigns.ITableItem[]): NSPromoCampaigns.IFormattedItem[] =>
    dataTable.map((table) => ({
      _id: table._id,
      status: table.status,
      internalName: table.internalName,
      publicCode: table.publicCode,
      type: table.type,
      codeType: table.codeType,
      targetPackage: table.targetPackage,
      generatedCodeCount: table.generatedCodeCount,
      insertedCodeCount: table.insertedCodeCount,
      usedCodeCount: table.usedCodeCount,
    }));

  const columns = useColumnsHeaders([
    { accessorAsHeader: 'status' },
    { accessorAsHeader: 'internalName' },
    { accessorAsHeader: 'publicCode' },
    { accessorAsHeader: 'type' },
    { accessorAsHeader: 'codeType' },
    { accessorAsHeader: 'targetPackage' },
    { accessorAsHeader: 'generatedCodeCount' },
    { accessorAsHeader: 'insertedCodeCount' },
    { accessorAsHeader: 'usedCodeCount' },
  ]);

  return (
    <TableWithState
      tableName={ETables.PromoCampaigns}
      dataFormatter={dataFormatter}
      cellStyleHandler={cellStyleHandler}
      columns={columns}
      exportable={true}
      addable={permissions.promoCampaigns.edit}
    />
  );
};

export default PromoCampaigns;
